module.exports = __webpack_public_path__ + "static/media/purple-card.6294e807.png";